// extracted by mini-css-extract-plugin
export default {"card":"inicio-card_card__pyuKq","icon":"inicio-card_icon__yGSHn","title":"inicio-card_title__gDmbI"};